import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ className = "", markClass = "h-16 w-16" }) => (
  <Link to="/" className={`flex items-center gap-3 shrink-0 ${className}`} data-testid="navbar-logo">
    <span className="bg-white rounded-xl p-1 shadow-md ring-2 ring-mango-600 border-2 border-mango-600 grid place-items-center shrink-0">
      <img src="/logo-mark.png" alt="agoomarket" className={`${markClass} object-contain`} />
    </span>
    <span className="font-display font-extrabold text-4xl sm:text-[2.4rem] tracking-tight lowercase leading-none">
      <span className="text-white">agoo</span><span className="text-mango-400">market</span>
    </span>
  </Link>
);
